// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5d6efced","453":"4a9285ae","455":"724864cd","977":"bbe6ce4a"}[chunkId] + ".chunk.js";
};